module.exports = __webpack_public_path__ + "img/logo-icon.c21bf58d.svg";